/*!
 * Copyright (c) 2026 GS Elektromedizinische Geraete G. Stemple GmbH, Germany - all rights reserved.
 * <p>
 * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
 */

@use '../../../variables';
@use '../../../mixins';

.timepicker-fieldset {
  position: relative;
  text-align: left;
  padding: 0 8px;
  border-radius: 4px;
  border-style: solid;
  border-width: 1px;
  overflow: hidden;
  min-width: 0;
  border-color: rgba(0, 0, 0, 0.23);
  color: rgba(0, 0, 0, 0.6);

  &.no-margin-top {
    margin-top: 0;
  }

  &:has(:hover) {
    border: variables.$color-black solid 1px;
  }

  &:has(:invalid) {
    border: variables.$color-corpuls-system-red solid 1px;
  }

  &:has(:focus) {
    border: variables.$color-orange solid 2px;
    color: variables.$color-orange; //label color
    padding-left: 7px; //prevents label from flickering right
  }

  .timepicker-legend {
    font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;
    font-size: 0.75rem;
    line-height: 0;
    padding: 0 4px 0 4px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    background-color: variables.$color-white;
  }

  .timepicker-input {
    font-family: monospace;
    font-size: 1.23125em;
    letter-spacing: inherit;
    color: variables.$color-black;
    border: none;
    box-sizing: content-box;
    background: none;
    height: 1.4375em;
    padding: 16px 1px 14px 1px;
    -webkit-tap-highlight-color: transparent;
    display: block;
    @include mixins.use-available-space;

    &:focus {
      outline: none;
      padding: 15px 0 13px 1px;
    }
  }

  .timepicker-input::-webkit-calendar-picker-indicator {
    width: 23px;
    height: 23px;
  }

  .warning-symbol {
    position: absolute;
    // do not overlap the time-picker icon (only available in chrome and edge)
    right: 55px;
    top: 0;
    bottom: 0;
    margin: auto;
    width: 27px;
    height: 27px;
  }
}
